
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './styles/ProductPageHeader.scss';

export default function ProductPageHeader(props) {
    const user = props.merchant.user;  
    return (
        <Row className="product-header justify-content-between align-items-center">
            <Col lg={6} md={6}>
                {(() => {
                    if (user['brand_logo']) {
                        return (<img className="sellerImg" src={user['brand_logo']} />);
                    }
                    else if (user['company_name']) {
                        return (<h2 className="t-primary">{user['company_name']}</h2>);
                    }
                    else {
                        return (<h2 className="t-primary">{user['fullname']}</h2>);
                    }
                })()}
            </Col>
            { props.children }
        </Row>
    );
}
ProductPageHeader.propTypes = {
    merchant: PropTypes.object,
    children: PropTypes.any
};
